// extracted by mini-css-extract-plugin
export default {"roundedButton":"roundedButton_roundedButton__6quvB"};